import { useReduxState } from 'hooks';
import { Checkbox, FormGroup } from 'components/common/form';
import { SiteSettingsForm } from '.';

const SiteSettingsGroups = () => {
  const { messages, serverConfig } = useReduxState();

  const {
    enableGroupInfo,
    groupsAllowNonAdminGroupAdmins,
    groupsMakeAllAvailableForAdmins
  } = serverConfig;

  const initialValues = {
    enableGroupInfo,
    groupsAllowNonAdminGroupAdmins,
    groupsMakeAllAvailableForAdmins
  };

  return (
    <div className="settings-groups">
      <SiteSettingsForm
        initialValues={initialValues}
        title={messages.commonGroups}
      >
        {(formState) => (
          <div>
            <FormGroup label={messages.siteSettingsGroupInfo}>
              <Checkbox
                field="enableGroupInfo"
                id="enable-group-info"
                label={messages.siteSettingsEnableGroupInfo}
              />
            </FormGroup>

            <FormGroup label={messages.commonAdministrators}>
              <Checkbox
                field="groupsAllowNonAdminGroupAdmins"
                id="groups-allow-non-admin-group-admins"
                label={messages.siteSettingsGroupsAllowNonAdminGroupAdmins}
              />
            </FormGroup>

            <FormGroup label={'Available groups'}>
              <Checkbox
                field="groupsMakeAllAvailableForAdmins"
                id="groups-make-all-available-for-admins"
                label={'Make all groups available for admin-users'}
              />
            </FormGroup>
          </div>
        )}
      </SiteSettingsForm>
    </div>
  );
};

export default SiteSettingsGroups;
